import { module } from 'modujs';
import ModelViewer from './ModelViewer';
import { Vector3 } from 'three'

export default class extends ModelViewer {
    constructor(m) {
        super(m);
    }

    init() {
        super.init()

        // this.debugDiv = document.createElement('div')
        // this.debugDiv.setAttribute('style', 'position: absolute; inset: 0; color: chartreuse; z-index:9999; pointer-events: none; font-family: monospace;')
        // this.el.parentNode.append(this.debugDiv)

        // ==========================================================================
        // TAP HANDLING
        // ==========================================================================
        let clickStartTime;
        let clickStartPos;
        this.onClickStart = (e) => {
            clickStartTime = Date.now();
            clickStartPos = {
                x: e.touches ? e.touches[0].screenX : e.screenX,
                y: e.touches ? e.touches[0].screenY : e.screenY,
            }
        }

        this.onClickEnd = (e) => {
            const deltaTime = Date.now() - clickStartTime

            const clickEndPos = {
                x: e.changedTouches ? e.changedTouches[0].screenX : e.screenX,
                y: e.changedTouches ? e.changedTouches[0].screenY : e.screenY,
            }
            let deltaPos = Math.abs(Math.sqrt(Math.pow(clickStartPos.x - clickEndPos.x, 2) + Math.pow(clickStartPos.y - clickEndPos.y, 2)))

            if(deltaTime < 250 && deltaPos < 10) {
                this.setModel(this.currentModel)
                if(window.gtag) {
                    gtag("event", "click", {
                        "event_category": "team_modal",
                        "event_label": "change_dance"
                    });
                }
            }
        }

        this.el.addEventListener('pointerdown', this.onClickStart);
        this.el.addEventListener('pointerup', this.onClickEnd);
    }

    initRenderer() {
        super.initRenderer();

        // this.renderer.setClearColor( 0xff0000, 0);
        // this.renderer.setClearAlpha(1)
    }

    initScene() {
        super.initScene();

        this.camera.position.set(-2,2,2.9)
        this.controls.target.set(0, .9, 0)

        this.controls.zoomSpeed = 0.5

        this.controls.minDistance = 1;
        this.controls.maxDistance = 5;
        this.controls.maxPolarAngle = Math.PI * 0.60;
        this.controls.minPolarAngle = Math.PI * 0.30;

        var minPan = new Vector3( -1, -1, -1 );
        var maxPan = new Vector3( 1, 2, 1 );
        var _v = new Vector3();

        this.onControlsChange = () => {
             _v.copy(this.controls.target);
             this.controls.target.clamp(minPan, maxPan);
             _v.sub(this.controls.target);
             this.camera.position.sub(_v);
        }
        this.controls.addEventListener("change", this.onControlsChange)
    }

    render() {
        super.render();

        // function round(val) {
        //     return Math.round(val*100)/100;
        // }

        // if(this.debugDiv) {
        //     this.debugDiv.innerHTML = `
        //         CAMERA: ${round(this.camera.position.x)},${round(this.camera.position.y)},${round(this.camera.position.z)}<br>
        //         TARGET: ${round(this.controls.target.x)},${round(this.controls.target.y)},${round(this.controls.target.z)}
        //     `
        // }
    }

    destroy() {
        this.controls.removeEventListener("change", this.onControlsChange)

        this.el.removeEventListener('pointerdown', this.onClickStart);
        this.el.removeEventListener('pointerup', this.onClickEnd);

        super.destroy();
    }
}
